define('contentPreload',['helpers', 'training'], function(helpers, Training) {
    'use strict';

    function ContentPreload(options) {

        options = options || {};

        this.entityContent = options.entityContent || null;
        this.entities = options.entities || null;
        this.debugMode = options.debugMode || false;

        this.ID = (this.entityContent) ? this.entityContent.ID : '';

        this.entity = helpers.content.getEntity(this.ID, this.entities);

        this.children = (this.entity && this.entity.hasOwnProperty('children') && Array.isArray(this.entity.children)) ? this.entity.children : [];
        this.answers = (this.entity && this.entity.hasOwnProperty('answers') && Array.isArray(this.entity.answers)) ? this.entity.answers : [];
        this.content = (this.entity && this.entity.hasOwnProperty('contentEntity')) ? this.entity.contentEntity : {};

        this.pagesID = [];
        this.images = [];

        this.training = new Training();

        if (this.ID && this.entities) {
            this.init();
        }
    }

    ContentPreload.prototype.parseChildren = function(children) {
        for (var i = 0; i < children.length; i++) {
            this.pagesID.push(children[i].contentEntityId);

            if (children[i].children.length) {
                this.parseChildren(children[i].children);
            }
        }
    };

    ContentPreload.prototype.parseChild = function(children) {
        var firstChild = children[0];

        if (firstChild && firstChild.hasOwnProperty('contentEntityId') && firstChild.contentEntityId) {
            this.pagesID.push(firstChild.contentEntityId);
        }
    };

    ContentPreload.prototype.parseAnswers = function(answers) {
        var i = answers.length;

        while(i--) {
            if (answers[i].hasOwnProperty('naviTargetId') && answers[i].naviTargetId) {
                this.pagesID.push(answers[i].naviTargetId);
            }
        }
    };

    ContentPreload.prototype.parseTrainingMap = function() {
        var trainingMap = helpers.content.getTrainingMap(this.entities),
            index = trainingMap.indexOf(this.ID),
            prevID = (index !== 0) ? trainingMap[(index-1)] : '',
            nextID = (index > -1 && index < trainingMap.length - 1) ? trainingMap[(index+1)] : '';

        if (prevID && this.pagesID.indexOf(prevID) === -1) {
            this.pagesID.push(prevID);
        }

        if (nextID && this.pagesID.indexOf(nextID) === -1) {
            this.pagesID.push(nextID);
        }
    };

    ContentPreload.prototype.addImageID = function(mediaID) {
        if (mediaID) {
            this.images.push(this.training.getMediaURL(mediaID));
        }
    };

    ContentPreload.prototype.addImageURL = function(mediaURL) {
        if (mediaURL) {
            this.images.push(this.training.parseMediaURL(mediaURL));
        }
    };

    ContentPreload.prototype.parseComponent = function(content, arr, type) {
        var i = 0,
            _this = this;

        switch(type) {
        case 'custom':

            for ( ; i < arr.length; i++) {
                _this.addImageURL(arr[i].source);
            }

            break;
        case 'extra':

            for ( ; i < arr.length; i++) {
                _this.addImageURL(arr[i].image);
            }

            break;
        case 'hotspots':

            this.addImageURL(content.backgroundImage);

            for ( ; i < arr.length; i++) {
                _this.addImageURL(arr[i].image);
            }

            break;
        case 'video':

            for ( ; i < arr.length; i++) {
                _this.addImageURL(arr[i].poster);
            }

            break;
        default:

        }
    };

    ContentPreload.prototype.parseEntitiesContent = function(pagesID) {
        var i = pagesID.length,
            entity,
            componentsJSON,
            components = {};

        if (this.debugMode) {
            console.log('Parsing entities for preload:');
            console.dir(pagesID);
        }

        while(i--) {
            entity = helpers.content.getEntity(pagesID[i], this.entities);

            if (!entity) {
                return;
            }

            if (entity.contentEntity.hasOwnProperty('imageId') && entity.contentEntity.imageId) {
                this.addImageID(entity.contentEntity.imageId);
            }

            if (!entity.contentEntity.hasOwnProperty('componentsJson') || !entity.contentEntity.componentsJson) {
                return;
            }

            componentsJSON = JSON.parse(entity.contentEntity.componentsJson);

            components.hotspots = helpers.component.getContent(componentsJSON, 'Hotspots') || null;
            if (components.hotspots) {
                this.parseComponent(components.hotspots, helpers.component.parseProp(components.hotspots, 'items', 'HotspotsItem'), 'hotspots');
            }

            components.video = helpers.component.getContent(componentsJSON, 'Video') || null;
            if (components.video) {
                this.parseComponent(components.video, helpers.component.parseProp(components.video, 'video', 'VideoItem'), 'video');
            }

            components.extra = helpers.component.getContent(componentsJSON, 'ExtraInfoContent') || null;
            if (components.extra) {
                this.parseComponent(components.extra, helpers.component.parseProp(components.extra, 'items', 'ExtraContentItem'), 'extra');
            }

            components.custom = helpers.component.getContent(componentsJSON, 'CustomComponent') || null;
            if (components.custom) {
                this.parseComponent(components.custom, helpers.component.parseProp(components.custom, 'images', 'ImageWithId'), 'custom');
            }

            components.custom2 = helpers.component.getContent(componentsJSON, 'CustomComponent2') || null;
            if (components.custom2) {
                this.parseComponent(components.custom2, helpers.component.parseProp(components.custom2, 'images', 'ImageWithId'), 'custom');
            }
        }
    };

    /* http://www.photo-mark.com/notes/image-preloading/*/
    ContentPreload.prototype.preloadContent = function(images, i) {
        var img,
            _this = this;

        i = i || 0;

        if (images.length > i) {
            img = new Image ();
            img.onload = function() {
                _this.preloadContent(images, ++i);
            };
            img.src = images[i];

            if (this.debugMode) {
                console.log('Preloading: ' + images[i]);
            }
        } else if (this.debugMode) {
            console.log('Preload complete');
        }
    };

    ContentPreload.prototype.init = function() {

        if (!this.entity) {
            return;
        }

        if (this.entity.typeId !== 10 && this.answers.length) {
            this.parseAnswers(this.answers);
        }

        if (this.content.hasOwnProperty('naviTargetId') && this.content.naviTargetId) {
            this.pagesID.push(this.content.naviTargetId);
        } else {
            if (helpers.entity.isQuizGamePage(this.entity) || helpers.entity.isQuizPage(this.entity)) {
                this.parseChildren(this.children);
            } else if (this.children.length) {
                this.parseChild(this.children);
            }
            this.parseTrainingMap();
        }

        if (this.pagesID.length) {
            this.parseEntitiesContent(this.pagesID);
        }

        if (this.images.length) {
            this.preloadContent(this.images);
        } else if (this.debugMode) {
            console.log('Nothing to preload');
        }
    };

    return ContentPreload;

});

